import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";
import ShoppingContext from "../../contexts/ShoppingContext";

import { ReactComponent as ArrowDownThingSvg } from "../../assets/icons/top-arrow-noline-primary.svg";
import { ReactComponent as CloseSvg } from "../../assets/icons/close-primary.svg";
import { Field, Form, Formik } from "formik";
import Button from "../common/Button";
import OutsideClickHandler from "react-outside-click-handler";

const sortOptions = [
  {
    value: 1,
    name: "Newest",
    sort: {
      createdOn: -1,
    },
  },
  {
    value: 2,
    name: "Oldest",
    sort: {
      createdOn: 1,
    },
  },
];

const Filter = ({ isMobile, handleSearch, onClose }) => {
  const { designStyles, getLang } = useContext(AppContext);
  const { shoppingFilter, setShoppingFilter } = useContext(ShoppingContext);
  const [toggleCategories, setToggleCategories] = useState({
    works: false,
    spaces: false,
    styles: false,
  });
  const TranslationCommon = getLang(langComponent.common);
  const TranslationWorkType = getLang(langComponent.workType);
  const TranslationSpaceType = getLang(langComponent.spaceType);
  const TranslationStyleType = getLang(langComponent.styleType);
  const formikRef = useRef();
  const [initialValues] = useState(shoppingFilter ?? {});

  const handleToggleCategories = (type) => {
    setToggleCategories((curr) => {
      return {
        ...curr,
        [type]: !curr[type],
      };
    });
  };

  const handleSubmit = ({ works, spaces, styles }, options) => {
    const _newFilter = {
      typeOfWork: works,
      typeOfSpace: spaces,
      typeOfStyle: styles,
    };

    // * Filter all if none were selected
    if (works.length === 0) delete _newFilter.typeOfWork;
    if (spaces.length === 0) delete _newFilter.typeOfSpace;
    if (styles.length === 0) delete _newFilter.typeOfStyle;

    setShoppingFilter(_newFilter);
    onClose();
  };

  if (isMobile) {
    return "Mobile Menu";
  }

  const {
    works: toggleWorks,
    spaces: toggleSpaces,
    styles: toggleStyles,
  } = toggleCategories;

  return (
    <Formik
      initialValues={{
        works: initialValues.typeOfWork ?? [],
        spaces: initialValues.typeOfSpace ?? [],
        styles: initialValues.typeOfStyle ?? [],
      }}
      onSubmit={handleSubmit}
      innerRef={formikRef}
    >
      {(props) => {
        return (
          <Form className="shopping-filter">
            <OutsideClickHandler onOutsideClick={onClose}>
              <div className="shopping-filter-content">
                <div className="shopping-filter-header">
                  <h3 className="shopping-filter-header__title">Filters</h3>
                  <CloseSvg width="24" onClick={onClose} />
                </div>
                <div className="shopping-filter-category">
                  <div
                    className="shopping-filter-category-header"
                    onClick={() => handleToggleCategories("works")}
                  >
                    <span className="shopping-filter-category-header__title">
                      Works
                    </span>
                    <ArrowDownThingSvg
                      className={`shopping-filter-category-header__toggler ${
                        toggleWorks
                          ? "shopping-filter-category-header__toggler--active"
                          : ""
                      }`}
                      width="24"
                    />
                  </div>
                  {toggleWorks && (
                    <div
                      className="shopping-filter-category-list"
                      role="group"
                      aria-labelledby="checkbox-group"
                    >
                      {designStyles.works.map(({ name, value }) => {
                        return (
                          <label
                            className="shopping-filter-category-list-option"
                            key={name + value}
                          >
                            <Field
                              className="shopping-filter-category-list-option__label"
                              type="checkbox"
                              name="works"
                              value={value}
                            />
                            {TranslationWorkType(name)}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="shopping-filter-category">
                  <div
                    className="shopping-filter-category-header"
                    onClick={() => handleToggleCategories("spaces")}
                  >
                    <span className="shopping-filter-category-header__title">
                      Spaces
                    </span>
                    <ArrowDownThingSvg
                      className={`shopping-filter-category-header__toggler ${
                        toggleSpaces
                          ? "shopping-filter-category-header__toggler--active"
                          : ""
                      }`}
                      width="24"
                    />
                  </div>
                  {toggleSpaces && (
                    <div
                      className="shopping-filter-category-list"
                      role="group"
                      aria-labelledby="checkbox-group"
                    >
                      {designStyles.spaces.map(({ name, value }) => {
                        return (
                          <label
                            className="shopping-filter-category-list-option"
                            key={name + value}
                          >
                            <Field
                              className="shopping-filter-category-list-option__label"
                              type="checkbox"
                              name="spaces"
                              value={value}
                            />
                            {TranslationSpaceType(name)}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div className="shopping-filter-category">
                  <div
                    className="shopping-filter-category-header"
                    onClick={() => handleToggleCategories("styles")}
                  >
                    <span className="shopping-filter-category-header__title">
                      Styles
                    </span>
                    <ArrowDownThingSvg
                      className={`shopping-filter-category-header__toggler ${
                        toggleStyles
                          ? "shopping-filter-category-header__toggler--active"
                          : ""
                      }`}
                      width="24"
                    />
                  </div>
                  {toggleStyles && (
                    <div
                      className="shopping-filter-category-list"
                      role="group"
                      aria-labelledby="checkbox-group"
                    >
                      {designStyles.styles.map(({ name, value }) => {
                        return (
                          <label
                            className="shopping-filter-category-list-option"
                            key={name + value}
                          >
                            <Field
                              className="shopping-filter-category-list-option__label"
                              type="checkbox"
                              name="styles"
                              value={value}
                            />
                            {TranslationStyleType(name)}
                          </label>
                        );
                      })}
                    </div>
                  )}
                </div>
                <div style={{ flexGrow: 1 }} />
                <div className="shopping-filter-ctas">
                  <Button
                    label={"Clear filters"}
                    variant={"secondary"}
                    onClick={() => {
                      props.setFieldValue("works", []);
                      props.setFieldValue("spaces", []);
                      props.setFieldValue("styles", []);
                    }}
                  />
                  <Button label={"Apply"} type="submit" />
                </div>
              </div>
            </OutsideClickHandler>
          </Form>
        );
      }}
    </Formik>
  );
};

Filter.propTypes = {};

Filter.defaultProps = {};

export default Filter;
